import { createContextFactory } from './createContextFactory';
const initialState = {
  defaultCurrencyCode: 'USD',
  availableCurrencyCodes: ['USD'],
  showCurrencyCodeUnit: false
};
export const {
  Provider: CurrencyContextProvider,
  useGetStore: useGetCurrencyStore,
  useSetStore: useSetCurrencyStore
} = createContextFactory({
  initialState,
  loggerOn: false,
  contextName: 'CurrencyContext'
});